import { StepProgressBarSkeleton } from '@components/step-progress-bar/skeleton/step-progress-bar-skeleton';
import { StepProgressBar } from '@components/step-progress-bar/step-progress-bar';
import { IconTypes } from '@eika/icon';
import { useProcess } from '@react-query/hooks/query/use-process';
import { useTranslation } from '@translations';
import { approverParentHasConsented, isComplete, isWaitingForApproverParentConsent } from '@utils/process-utils';
import { ScreenReaderProcessStatus } from '../screen-reader/screen-reader-process-status';
import { getActiveStep, getIconFirstStep, getLabelFirstStep, getLabelSecondStep } from './utils';

export const ProcessProgress = () => {
    const { data: process, isPending, error } = useProcess();
    const { pendingProcess } = useTranslation();

    if (isPending) {
        return <StepProgressBarSkeleton data-testid="loading-process-progress" />;
    }

    if (error) {
        return <div data-testid="error-process-progress">Error loading process details</div>;
    }

    return (
        <>
            <StepProgressBar
                isComplete={isComplete(process)}
                activeStep={getActiveStep(process)}
                data-testid="process-progress"
                aria-hidden="true"
            >
                <StepProgressBar.Step
                    iconType={getIconFirstStep(process)}
                    completed={isWaitingForApproverParentConsent(process)}
                >
                    {getLabelFirstStep(process, pendingProcess)}
                </StepProgressBar.Step>
                <StepProgressBar.Step iconType={IconTypes.FAMILIE_24} completed={approverParentHasConsented(process)}>
                    {getLabelSecondStep(process, pendingProcess)}
                </StepProgressBar.Step>
                <StepProgressBar.Step iconType={IconTypes.MOBILBANK_24} completed={isComplete(process)}>
                    {pendingProcess.progress.complete}
                </StepProgressBar.Step>
            </StepProgressBar>

            {/* For a11y */}
            <ScreenReaderProcessStatus />
        </>
    );
};
